// SignupScreen.js (ReactJS Version)
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, InputGroup, Spinner } from 'react-bootstrap';
// import './SignupScreen.css';

const SignupScreen = () => {
  const [membershipNo, setMembershipNo] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [select, setSelect] = useState('Select Club');
  const [isClicked, setIsClicked] = useState(false);
  const [clubName, setClubName] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [ads, setAds] = useState([]);

  const dist = sessionStorage.getItem("dist");

  const fetchClubs = async () => {
    const res = await axios.get(`https://lionsdirectoryapi.emedha.in/club/api/clubName/get?dist=${dist}`);
    setClubName(res.data);
  };

  const handleSearch = (term) => {
    axios.post('https://lionsdirectoryapi.emedha.in/club/api/search/club', {
      search: term,
      dist: dist,
    }).then((res) => setClubName(res.data));
  };

  const handleSelectClub = (name) => {
    setSelect(name);
    setIsClicked(false);
  };

  const fetchAds = () => {
    axios.post('https://lionsdirectoryapi.emedha.in/notification/api/advertise/get', {
      ad_page: 'signup',
      dist,
    }).then(res => setAds(res.data));
  };

  const handleSignup = async () => {
    try {
      const res = await axios.post('https://lionsdirectoryapi.emedha.in/signup/post', {
        mobile,
        membershipNo,
        password,
        select,
        dist,
      });

      if (res.data === "Signup successful!") {
        alert("Signup successful! Please login.");
        window.location.href = '/app/login';
      } else if (res.data === "User already exists") {
        alert("User already registered! Please login or reset your password.");
      } else {
        alert(res.data || 'An error occurred.');
      }
    } catch (err) {
      alert("Network error or user already registered.");
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

const previewContainerStyle = {
  width: '375px',
  minHeight: '667px', // iPhone 8/SE 2nd Gen height
  margin: '20px auto',
  border: '1px solid #ccc',
  borderRadius: '20px',
  overflow: 'hidden',
  boxShadow: '0 0 10px rgba(0,0,0,0.2)',
  backgroundColor: '#f8f9fa', // Optional for visual clarity
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};


  return (
      <div style={previewContainerStyle}>
    <div className="signup-container">
      <div className="signup-header bg-primary text-white p-2 text-center">
        <h5>Lions {dist}</h5>
      </div>

      <div className="signup-body p-3">
        {ads.map((data) => (
          <img key={data.id} src={data.image} alt="ad" className="img-fluid mb-3"  style={{width: 340, height: 250}}/>
        ))}

        <Form>
          <Form.Group>
            <Form.Label>Mobile</Form.Label>
            <Form.Control
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Mobile"
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Membership Number</Form.Label>
            <Form.Control
              type="text"
              value={membershipNo}
              onChange={(e) => setMembershipNo(e.target.value)}
              placeholder="Enter Membership No"
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Club</Form.Label>
            <InputGroup>
              <Form.Control
                readOnly
                value={select}
                onClick={() => {
                  setIsClicked(true);
                  fetchClubs();
                }}
              />
            </InputGroup>
          </Form.Group>

          {isClicked && (
            <div className="club-list border rounded p-2">
              <Form.Control
                placeholder="Search Clubs"
                onChange={(e) => handleSearch(e.target.value)}
                className="mb-2"
              />
              {clubName.map((club, idx) => (
                <div
                  key={idx}
                  className="club-item"
                  onClick={() => handleSelectClub(club.clubName)}
                >
                  {club.clubName}
                </div>
              ))}
            </div>
          )}

          <Form.Group className="mt-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
            />
          </Form.Group>

          <Button className="mt-4 w-100" onClick={handleSignup} variant="primary">
            Sign Up
          </Button>

          <div className="text-center mt-3">
            <a href="/app/login">Already have an account? Login</a>
          </div>

          <div className="text-center mt-2">
            <a onClick={() => setModalVisible(true)} style={{color:'InfoText'}}>
              Forgot or want to change password?
            </a>
          </div>
        </Form>
      </div>

      <Modal show={modalVisible} onHide={() => setModalVisible(false)} centered>
        <Modal.Body>
          <p className="text-center">Dear User, Kindly contact your district administration to reset password.</p>
          <div className="d-flex justify-content-center">
            <Button variant="secondary" onClick={() => setModalVisible(false)}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className="signup-footer text-center bg-primary text-white p-2">
        @ 2025 Lions {dist} Club. All rights reserved.
      </div>
    </div>
    </div>
  );
};

export default SignupScreen;
